var nanobus = require('nanobus');
var ListscreenInitialize = /** @class */ (function () {
    function ListscreenInitialize(list_screens) {
        this.list_screens = list_screens;
        this.processed = [];
        this.errors = [];
        this.success = [];
        this.events = nanobus();
    }
    ListscreenInitialize.prototype.doAjaxCall = function (list_screen) {
        return jQuery.ajax({
            url: list_screen.screen_link,
            method: 'get',
        });
    };
    ListscreenInitialize.prototype.run = function () {
        var _this = this;
        Object.keys(this.list_screens).forEach(function (key) {
            _this.processListScreen(_this.list_screens[key]);
        });
    };
    ListscreenInitialize.prototype.onFinish = function () {
        if (this.success.length === Object.keys(this.list_screens).length) {
            this.events.emit('success');
        }
        if (this.errors.length > 0) {
            this.events.emit('error');
        }
    };
    ListscreenInitialize.prototype.checkFinish = function () {
        if (this.processed.length === Object.keys(this.list_screens).length) {
            this.onFinish();
        }
    };
    ListscreenInitialize.prototype.processListScreen = function (list_screen) {
        var _this = this;
        return this.doAjaxCall(list_screen)
            .done(function (r) {
            if (r === 'ac_success') {
                _this.success.push(list_screen);
            }
            else {
                _this.errors.push(list_screen);
            }
        })
            .fail(function () {
            _this.errors.push(list_screen);
        })
            .always(function () {
            _this.processed.push(list_screen);
            _this.checkFinish();
        });
    };
    return ListscreenInitialize;
}());
var ListScreenInitializeController = /** @class */ (function () {
    function ListScreenInitializeController(list_screens) {
        this.list_screens = list_screens;
        this.run();
    }
    ListScreenInitializeController.prototype.run = function () {
        var _a;
        if (Object.keys(this.list_screens).length > 0) {
            // Only load main screen first if unitialized, otherwise do the rest in background
            if (this.list_screens.hasOwnProperty(AC.list_screen)) {
                var main_initializer = new ListscreenInitialize((_a = {}, _a[AC.list_screen] = this.list_screens[AC.list_screen], _a));
                main_initializer.run();
                main_initializer.events.on('error', function () {
                    document.querySelectorAll('.ac-loading-msg-wrapper').forEach(function (el) { return el.remove(); });
                    document.querySelectorAll('.menu').forEach(function (el) { return el.classList.remove('hidden'); });
                });
                main_initializer.events.on('success', function () {
                    window.location = location.href + "&t=" + Date.now();
                });
            }
            else {
                var background_initializer = new ListscreenInitialize(this.list_screens);
                background_initializer.run();
            }
        }
    };
    return ListScreenInitializeController;
}());
export default ListScreenInitializeController;
